import React from 'react';

import cx from 'classnames';
import { Link } from 'react-scroll';

import Icon from 'components/shared/Icon';
import ScrollArrow2 from 'components/shared/Icon/icons/ScrollArrow2';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import s from './index.module.css';
import { IStartArrowProps } from './types';

function StartArrow(props: IStartArrowProps) {
  const { to, containerId } = props;
  const { isTabletOrMobile } = useMediaBreakpoints();
  const offset = isTabletOrMobile ? -80 : 1;

  return (
    <Link
      to={to || ''}
      className={cx(s.link, 'custom-start-arrow')}
      containerId={containerId}
      smooth={true}
      duration={200}
      offset={offset}
      isDynamic
    >
      <Icon component={ScrollArrow2} className={cx(s.icon, 'custom-start-arrow-link')} />
    </Link>
  );
}

export default StartArrow;
